.dealAttr {
  display: flex;
  width: 33%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0 1rem;
}

.dealAttrbox {
  display: flex;
  flex-direction: column;
  align-items: first baseline;
}

.attrTitle {
  text-align: center;
  padding-bottom: 0.1rem;
}

.attrVal {
  text-align: center;
  font-weight: 500;
}

.netIRR {
  composes: attrVal;
  font-weight: bold;
}
